import React, { useState, useEffect } from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

import { Table, TableBody, TableCell, TableHead, TableRow, Button, TextField } from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RowVehicle from './RowVehicle';

import { getApi } from '../../api';

const vehicle_type = [
  {
    value: 'sedan',
    label: 'sedán',
  },
  {
    value: 'minibus',
    label: 'micro-bus',
  },
  {
    value: 'bus',
    label: 'bus',
  },
  {
    value: 'off_road',
    label: 'todo terreno',
  },
];

const vehicle_status = [
  {
    value: 'out_of_service',
    label: 'Fuera de servicio',
  },
  {
    value: 'available',
    label: 'Disponible',
  },
];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
      overflowX: 'auto',
    },
    table: {
      minWidth: 650,
    },
    button: {
      marginRight: 10
    }
  }),
);

async function getVehicles() {
  try {
    //* *Make post user */
    const response = await getApi().get('/vehicles', { data: {} });

    return response;
  } catch (e) {
    // console.log("e:");
    // console.log(e.status);
  }
}

export default function Vehicles() {
  const classes = useStyles();
  const [vehicles, setVehicles] = useState({
    isLoading: true,
    list: [],
  });

  const [newVehicle, setNewVehicle] = useState({
    isNew: false,
    description: '',
    license_plate: '',
    password: '',
    capacity: '',
    vehicle_type: 'sedan',
    status: 'available',
  });

  const handleVehicleChange = name => event => {
    setNewVehicle({
      ...newVehicle,
      [name]: event.target.value,
    });
  };

  useEffect(() => {
    async function loadvehicles() {
      try {
        if (vehicles.isLoading) {
          const response = await getVehicles();
          // console.log(response.data);
          if (response.status === 200) {
            setVehicles({
              ...vehicles,
              isLoading: false,
              list: response.data.sort((a, b) => (a.id < b.id ? 1 : -1)),
            });
          }
        }
      } catch (error) {}
    }

    loadvehicles();
  }, [vehicles]);

  const handleSubmitVehicle = async () => {
    // make insert
    try {
      const vehicle = newVehicle;
      const response = await getApi().post(
        '/vehicles',
        {
          vehicle,
        },
        '',
      );

      //* *200 authorized*/
      if (response !== undefined && response.status === 200) {
        // openClose();
        setNewVehicle({
          ...newVehicle,
          isNew: false,
          description: '',
          license_plate: '',
          password: '',
          capacity: '',
          vehicle_type: 'sedan',
          status: 'available',
        });
        setVehicles({ ...vehicles, isLoading: true });
      }
    } catch (error) {
      // handleError(error);
    }
  };

  return (
    <>
      <p>Administrar vehículos</p>
      {newVehicle.isNew ? (
        <>
          <TextField
            id="outlined-full-width"
            label="Placa"
            style={{ margin: 8 }}
            // placeholder="Nombre"
            fullWidth
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleVehicleChange('license_plate')}
          />
          <TextField
            id="outlined-select-currency-native"
            select
            label="Tipo"
            style={{ margin: 8 }}
            // className={classes.textField}
            value={newVehicle.vehicle_type}
            onChange={handleVehicleChange('vehicle_type')}
            SelectProps={{
              native: true,
            }}
            fullWidth
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          >
            {vehicle_type.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
          <TextField
            id="outlined-full-width"
            label="Capacidad"
            style={{ margin: 8 }}
            // placeholder="Nombre"
            fullWidth
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleVehicleChange('capacity')}
          />
          <TextField
            id="outlined-select-currency-native"
            select
            label="Estado"
            style={{ margin: 8 }}
            // className={classes.textField}
            value={newVehicle.status}
            onChange={handleVehicleChange('status')}
            SelectProps={{
              native: true,
            }}
            fullWidth
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          >
            {vehicle_status.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
          <TextField
            id="outlined-full-width"
            label="Observaciones"
            style={{ margin: 8 }}
            // placeholder="Nombre"
            fullWidth
            margin="normal"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            onChange={handleVehicleChange('description')}
          />
        </>
      ) : (
        ''
      )}
      {newVehicle.isNew && (
        <Button
          variant="contained"
          className={classes.button}
          color={'primary'}
          onClick={() => {
            handleSubmitVehicle();
          }}
          startIcon={<CheckCircleOutlineIcon />}
        >
          Guardar
        </Button>
      )}

      <Button
        variant="contained"
        className={classes.button}
        color={!newVehicle.isNew ? 'primary' : 'secondary'}
        onClick={event => setNewVehicle({ ...newVehicle, isNew: !newVehicle.isNew })}
        startIcon={!newVehicle.isNew ? <AddCircleOutlineIcon /> : <CancelOutlinedIcon />}
      >
        {!newVehicle.isNew ? 'Nuevo vehículo' : 'Cancelar'}
      </Button>
      <br />
      <br />
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Placa</TableCell>
            <TableCell align="center">Tipo</TableCell>
            <TableCell align="center">Capacidad</TableCell>
            <TableCell align="center">Estado</TableCell>
            <TableCell align="left">Observaciones</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!vehicles.isLoading
            ? vehicles.list.map((row, index) => (
                <RowVehicle key={row.id} index={index} row={row} setVehicles={setVehicles} />
              ))
            : null}
        </TableBody>
      </Table>
    </>
  );
}
